import * as React from 'react';

import classnames from 'classnames';

import {InternalFeedbackBannerWrapper} from '../internal-feedback/internal-feedback-banner-wrapper';

import {PageWrapperContext} from './page-wrapper-context';

import styles from './page-wrapper.module.css';

type Props = {
    children?: React.ReactNode;
    header?: React.ReactNode;
    sidebar?: React.ReactNode;
    pageCanScroll?: boolean;
    minWidth?: number;
    flashBanner?: React.ReactNode;
    isEmbedded?: boolean;
    borderTopLeftColor?: 'primary' | 'secondary';
};

/*
This component provides a consistent outer container to any
page layout. It should wrap the entire content of the page
 */
export function PageWrapper(props: Props) {
    return (
        <div
            className={classnames(styles['page-container-with-navbar'], {
                [styles['page-container-scrolling-sidebar']]: props.pageCanScroll && props.sidebar,
                [styles['page-container-fixed-sidebar']]: !props.pageCanScroll && props.sidebar,
                [styles['page-container-no-sidebar']]: !props.sidebar,
                [styles['page-container-border-top-left-primary']]:
                    props.borderTopLeftColor === 'primary',
                [styles['page-container-border-top-left-secondary']]:
                    props.borderTopLeftColor === 'secondary',
                [styles['page-container-embedded']]: props.isEmbedded,
            })}
        >
            {props.sidebar}
            <div key='main-content' className={styles['page-container']}>
                <InternalFeedbackBannerWrapper />
                {props.header ? props.header : null}
                <main
                    style={props.minWidth ? {minWidth: props.minWidth} : undefined}
                    className={styles.main}
                >
                    {/* @ts-expect-error */}
                    <PageWrapperContext.Provider value={{flashBanner: props.flashBanner}}>
                        {props.children}
                    </PageWrapperContext.Provider>
                </main>
            </div>
        </div>
    );
}
